import {Grid, Typography,Tooltip,IconButton,Switch, FormControlLabel, CircularProgress} from '@material-ui/core';
import {getHeadingCount,loadSkeleton,TOPIC_UTIL,getShuffledClusterColors} from '../../utility';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


function TopicBrief({showUnused,setShowUnused,viewHeadings,topics,topicName,topicClusteringSwitch,setTopicClusteringSwitch,topicClustering,clusteringLoadingState}){

    const css = `
        .brief-topic .brief-topic-switch-label span{
            font-size: 12px !important;
        }
    `;

    let clusterColors;
    // topic clustering
    if(topicClusteringSwitch && topicClustering){
        topics = _.sortBy(topics, (topic) => { return topic.cluster; });
        const colorSeed = topicName.length; // this ensures colors stay consistent within a brief
        clusterColors = getShuffledClusterColors(colorSeed);
    } else{
        topics = _.sortBy(topics, (topic) => {
          return -1 * topic.score;
        });
    }

    return(
        <Grid className="brief-topic" container xs="12"  direction="row" spacing={1} style={{backgroundColor:'white'}}>
            <style>{css}</style>
             <Grid xs="12" item style={{textAlign:'center'}} >
             </Grid>
                <Grid item xs="12"  direction="column" spacing={1} style={{margin:'0rem 0rem 0rem 0rem',background:'white'}}>
                    <div style={{paddingLeft: '1rem', marginBottom: '8px'}}>
                        <Typography variant="h6" color="primary" style={{fontWeight:'bold'}} gutterBottom>{TOPIC_UTIL.HEADER}</Typography>
                        <FormControlLabel 
                            value="Show Only Unused"
                            className="brief-topic-switch-label"
                            control={<Switch
                                color="primary"
                                checked={showUnused}
                                onChange={()=>setShowUnused(!showUnused)}
                                />}
                            label="Show Only Unused"
                            labelPlacement="end"
                            style={{display:'block'}}
                            gutterBottom
                        />
                        <FormControlLabel 
                            value="Group By Theme"
                            className="brief-topic-switch-label"
                            control={<Switch
                                color="primary"
                                checked={topicClusteringSwitch}
                                onChange={()=>setTopicClusteringSwitch(!topicClusteringSwitch)}
                                />}
                            label="Group By Theme"
                            labelPlacement="end"
                            gutterBottom
                        />
                        {clusteringLoadingState? <CircularProgress size={24} /> : null}
                    </div>
                    {(topics.length > 0)? 
                        (topics).map((topic,index) => {
                            const showClusterColor = _.isNumber(topic.cluster) && _.isArray(clusterColors);
                            let clusterColor;
                            if(showUnused){
                                if(topic.covered){
                                    return;
                                }
                            }

                            if(showClusterColor){
                                clusterColor = clusterColors[topic.cluster % clusterColors.length];
                            }
                            
                            return (
                                <Grid container xs="12" alignItems="center" style={{padding:'0.5rem 1rem', cursor: 'pointer', backgroundColor: (topic.covered ? 'rgb(213 233 214)' : 'inherit'), borderLeft: (clusterColor? `5px solid ${clusterColor}` : 'unset')}}>
                                    <Tooltip title={`Click to view Examples`} arrow>
                                        <Grid item xs="10" onClick={() => viewHeadings(topic)}>
                                            <Typography variant="subtitle1" style={{float:'left',width:'100%',fontWeight:'700',color:'#3e4b5b'}}>
                                                {topic.name}
                                            </Typography>
                                            <Typography variant="caption" style={{float:'left',color:'grey'}}>
                                                {TOPIC_UTIL.SOURCES_TEXT_1} <Typography variant="caption" style={{fontStyle:'italic'}}>{topic.summary && topic.summary.length}</Typography> {TOPIC_UTIL.SOURCES_TEXT_2}
                                            </Typography>
                                        </Grid>
                                    </Tooltip>
                                    <Grid item xs="2">
                                        {getHeadingCount(topic) > 0  && <Tooltip title={`used in ${getHeadingCount(topic)} Headings`}>
                                                <div style={{textAlign: 'right'}}><FontAwesomeIcon icon="heading" style={{opacity:'0.5'}} /></div>
                                        </Tooltip>}
                                    </Grid>
                                </Grid>
                            );
                        })
                    : 
                    loadSkeleton('text')
                    }
            </Grid>
        </Grid>
    );

}

export default TopicBrief;